import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

const CustomModal = ({ isOpen, hideModal, currentTitle, currentContent, buttons, className }) => (
  isOpen && <Fragment>
    <div className={'modal fade d-block show ' + className} tabIndex='-1' role='dialog' aria-labelledby='exampleModalLabel' aria-hidden='true'>
      <div className='modal-dialog modal-lg' role='document'>
        <div className='modal-content'>
          <div className='modal-header'>
            {currentTitle && <h5 className='modal-title'>{currentTitle}</h5>}
            {hideModal && <button className='close' onClick={hideModal} aria-label='Close'>
              <span aria-hidden='true'>&times;</span>
            </button>}
          </div>
          <div className='modal-body'>
            {currentContent ? currentContent : ''}
          </div>
          {buttons && <div className='modal-footer'>{buttons}</div>}
        </div>
      </div>
    </div>
    <div className='modal-backdrop fade show'></div>
  </Fragment>
);

CustomModal.propTypes = {
  isOpen: PropTypes.bool,
  hideModal: PropTypes.func,
  currentTitle: PropTypes.string,
  currentContent: PropTypes.object,
  buttons: PropTypes.object,
  className: PropTypes.string,
};

export default CustomModal;
